import {Component, OnInit} from '@angular/core';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {ActivatedRoute, Router} from '@angular/router';
import {UserNamespace} from '@namespaces/user.namespace';
import {EventsService} from '@services/events.service';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {TechnicalDeviceDataService} from '../services/technical-device-data.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {ScrollToService} from '@services/scroll-to.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-technical-device-view',
    templateUrl: 'technical-device-view.component.html'
})

export class TechnicalDeviceViewComponent implements OnInit {

    device: TechnicalDeviceNamespace.ApiDataInterface;

    permissions = UserNamespace.Permission;

    public objectUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private events: EventsService,
        private api: TechnicalDeviceApiService,
        private dataService: TechnicalDeviceDataService,
    ) {
    }

    ngOnInit() {
        this.device = this.route.snapshot.data.device;
        this.dataService.deviceId = this.device && this.device.id;
        this.dataService.workingObjectId = this.device && this.device.working_object && this.device.working_object.id;
        this.objectUrl = RoutesStorage.WorkingObject.view(this.device.working_object.id);
        ScrollToService.toTop();
    }

    remove() {
        if (!this.device) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить техническое устройство?',
            message: 'Также будут удалены все элементы и заключения',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.api.delete({
                id: this.device.id
            }).toPromise().then(() => {
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.technicalDeviceRemovedMessage
                });

                /**
                 * Переходим на объект
                 */
                this.router.navigate([this.objectUrl]);
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.technicalDeviceRemovedFailMessage
                });
            });
        }, () => {});
    }
}
